export const routes = {
  pageResolver: () => '/',
  formPage: () => '/form',
  login: () => '/login',
  subscribe: () => '/subscribe',
  unsubscribe: () => '/unsubscribe',
};
